import { getStylesObjFromCss } from "../../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    attachmentIcon: {
      fontSize: "20px !important",
      color: "#B9B9B9 !important",
      cursor: "pointer",
    },
    attachmentInputElement: {
      display: "none",
    },
  },
  componentName: "AttachmentSelector",
});
